const getPalaispaConfig = nodeEnv => {
    let baseURL;
    let proxyPrefix;
    switch (nodeEnv) {
        // dev
        case "dev":
        case "sit":
            baseURL = "https://palaispauat.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 预发布
        case "pre":
            baseURL = "https://palaispa-pre.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 正式
        case "prod":
            baseURL = "https://palaispa.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 默认
        default:
            baseURL = "http://localhost:8080";
            proxyPrefix = "/yapi";
            break;
    }
    return { baseURL, proxyPrefix };
};

export default getPalaispaConfig;



// WEBPACK FOOTER //
// ./src/api/palaispa/config.js